/**
 * A DataGrid-ek közös magyar feliratai. A huHU fordításból hiányzó
 * lapozó-feliratot („1–15 of 15”) pótoljuk. Ha egy grid saját `localeText`-et
 * ad meg (pl. egyedi „Nincs találat” szöveg), azt EHHEZ fűzze hozzá
 * (`{ ...huGridLocaleText, noRowsLabel: … }`) — a prop felülírja a témáét.
 */
import { huHU as gridHuHU } from '@mui/x-data-grid/locales';
import type { GridLocaleText } from '@mui/x-data-grid';
import { huPaginationDisplayedRows } from '../utils/gridPagination';

export const huGridLocaleText: Partial<GridLocaleText> = {
  ...gridHuHU.components.MuiDataGrid.defaultProps.localeText,
  paginationDisplayedRows: huPaginationDisplayedRows,
};

export const huGridLocalization = {
  components: {
    MuiDataGrid: {
      defaultProps: { localeText: huGridLocaleText },
    },
  },
};
